import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { Box, Typography, Paper } from '@mui/material';
import { BusinessRanking, CategoryRanking } from '../../services/analyticsService';

interface RankingChartProps {
  data: BusinessRanking[] | CategoryRanking[];
  title: string;
  dataKey: string;
  nameKey: string;
}

const RankingChart: React.FC<RankingChartProps> = ({ data, title, dataKey, nameKey }) => {
  // Colores para las barras (degradado de verde a rojo según posición)
  const COLORS = [
    '#4caf50', // Verde
    '#8bc34a',
    '#cddc39',
    '#ffeb3b',
    '#ffc107',
    '#ff9800',
    '#ff5722', // Rojo
    '#f44336',
  ];

  // Formatear datos para el gráfico
  const chartData = data.map((item: any) => ({
    name: item[nameKey].length > 25 ? item[nameKey].substring(0, 25) + '...' : item[nameKey],
    fullName: item[nameKey],
    value: parseFloat(item[dataKey] || '0'),
    auditorias: parseInt(item.total_auditorias || item.auditorias_evaluadas || '0'),
  }));

  // Componente de tooltip personalizado
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <Paper
          elevation={3}
          sx={{
            p: 1.5,
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Typography variant="body2" fontWeight="bold" gutterBottom>
            {data.fullName}
          </Typography>
          <Typography variant="body2" color="primary">
            Promedio: {data.value.toFixed(1)}%
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {dataKey.includes('categoria') ? 'Evaluaciones' : 'Auditorías'}: {data.auditorias}
          </Typography>
        </Paper>
      );
    }
    return null;
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
        {title}
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData} layout="vertical">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" domain={[0, 100]} style={{ fontSize: '12px' }} />
          <YAxis
            type="category"
            dataKey="name"
            width={150}
            style={{ fontSize: '11px' }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ fontSize: '14px' }} />
          <Bar dataKey="value" name="Promedio Cumplimiento" radius={[0, 4, 4, 0]}>
            {chartData.map((_entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default RankingChart;
